export const SET_SPECIFIC_VALUE = 'SET_SPECIFIC_VALUE';
export const SET_BUILDING_NAME = 'SET_BUILDING_NAME';
export const SET_ACTIVE_BUILD = 'SET_ACTIVE_BUILD';
